<template>
  <a-layout-content :class="!monitoring ? 'p-all' : '' ">
    <a-spin :spinning="pageLoading">
      <a-row :gutter="16">
        <a-col :xs="24" :lg="16">
          <a-card>
            <div slot="title">
              <span class="d-block">Manifest Alokasi</span>
              <small v-if="basedData.header">{{basedData.header.no_alokasi}}</small>
            </div>
            <div slot="extra">
              <a-popover v-model="visiblemenupopover" trigger="click" placement="bottomRight">
                <span slot="title">Pilih Aksi</span>
                <a-button icon="more">Aksi</a-button>
                <div class="m-list-wrapper bordered" slot="content">
                    <a-button
                      size="default"
                      style="width: 100%!important;"
                      block
                      @click="handlePrint"        
                      :loading="printLoading"
                      icon="printer"
                    >{{!isMobile ? 'Print Manifest' : '' }}</a-button>
                </div>
                <div class="m-list-wrapper bordered m-top-small" slot="content">
                    <a-button
                      v-if="getAuth.username == basedData.header.user_create && basedData.header.status=='Revised'"
                      size="default"
                      style="width: 100%!important;"
                      block
                      @click="handleEdit"
                      icon="edit"
                    >{{!isMobile ? 'Ubah' : '' }}</a-button>
                </div>
              </a-popover>
            </div>
            <ul class="list-wrapper bordered">
              <li>
                <span class="list-title" for>Tanggal Absensi</span>
                <span
                  class="list-desc"
                  v-if="basedData.header">{{moment(basedData.header.create_dt).format(getDefaultDateFormat)}}</span>
              </li>
              <li>
                <span class="list-title" for>Nama Pegawai</span>
                <span class="list-desc" v-if="basedData.header">{{basedData.header.tlc}}</span>
              </li>
              <li>
                <span class="list-title" for>Departemen / Divisi</span>
                <span class="list-desc" v-if="basedData.header">{{basedData.header.departemen}}</span>
              </li>
              <li>
                <span class="list-title" for>Jabatan</span>
                <span class="list-desc" v-if="basedData.header">{{basedData.header.posisi}}</span>
              </li>
              <li>
                <span class="list-title" for>Periode</span>
                <span
                  class="list-desc"
                  v-if="basedData.header"  >{{basedData.header.awal_periode + ' - ' + basedData.header.akhir_periode}}</span>
              </li>
              <li>
                <span class="list-title" for>Site</span>
                <span class="list-desc" v-if="basedData.header">{{basedData.header.site}}</span>
              </li>
              <li>
                <span class="list-title" for>Catatan</span>
                <span class="list-desc" v-if="basedData.header">{{basedData.header.catatan?basedData.header.catatan:''}}</span>
              </li>
            </ul>
          </a-card>
          <a-collapse activeKey="1" class="m-top">
            <a-collapse-panel key="1">
              <span slot="header">Detil Rekap Alokasi</span>
              <div class="m-form-item-wrapper">
                <a-table :columns="table_pekerjaan.columns" :data-source="basedData.detail" bordered :pagination="table_pekerjaan.pagination" :scroll="{ x: 1200, y: 500 }"
                  :loading="table_pekerjaan.loading" size="small" key="tblMonitoring" :rowKey="(record, index) => { return index; }">
                  <span slot="no" slot-scope="value, item, index">
                    {{ (table_pekerjaan.pagination.page - 1) * table_pekerjaan.pagination.pageSize + (index + 1) }}
                  </span>
                  <span slot="persentase" slot-scope="value, item, index">
                    {{ item.persentase }}%
                  </span>
                  <span slot="deskripsi" slot-scope="value, item, index">
                    {{ item.deskripsi }}
                  </span>
                </a-table>
              </div>
            </a-collapse-panel>
          </a-collapse>

          <a-card class="m-top" v-if="basedData.jenis !== 'Manifest'">
            <div slot="title">Tindakan Manifest</div>

            <a-form :form="form">
              <a-form-item class="m-remove" label="Catatan">
                <a-textarea
                  placeholder="Tulis catatan disini ... "
                  :rows="4"
                  v-decorator="['catatan']"
                />
              </a-form-item>
              <a-form-item label="Aksi">
                <a-select showSearch v-decorator="['aksi', {rules: [{required: true}]}]">
                  <a-select-option v-for="item in basedData.aksi" :key="item.aksi">{{item.aksi}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button @click="handleAction" block type="primary" html-type="submit">Simpan</a-button>
              </a-form-item>
            </a-form>
          </a-card>

        </a-col>
        <a-col :xs="24" :lg="8" :class="isMobile ? 'm-top' : ''">
          <a-collapse activeKey="1" forceRender >
            <a-collapse-panel key="1">
              <div class="d-flex justify-between align-middle" slot="header">
                <h4 class="margin-remove">Status</h4>
                <div>
                  <H-Status :status="basedData.status" />
                  <a-button  @click="handleHistory" type="default" size="small" class="m-right">
                    <a-icon type="undo" />
                    {{!isMobile ? 'Riwayat' : ''}}
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="grey">
                  <div class="m-timeline-title">Pembuat - {{basedData.header ? basedData.header.tlc: null}}</div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">{{basedData.header ? basedData.header.create_dt: null}}</h4>
<!--                    <span class="m-text-small">{{data.invoice.keperluan ? data.invoice.keperluan : 'Tidak Ada Keperluan'}}</span>-->
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">CREATED</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  :color="workflow.status === 'On Process' || workflow.status === 'Delivered' ? 'green' : workflow.status === 'Waiting' ? 'grey' : workflow.status === 'Rejected' || workflow.status === 'Revised' ? 'red' : 'grey'"
                  v-for="workflow in basedData.status_app"
                  :key="workflow.step_no"
                >
                  <div class="m-timeline-title">{{workflow.actor}} - {{workflow.tlc}}</div>
                  <div class="m-timeline-body">
                    <h4
                      class="margin-remove"
                      v-if="workflow.tanggal_aksi !== null"
                    >{{workflow.tanggal_aksi}}</h4>
                    <span class="m-text-small" v-if="workflow.remark">{{workflow.remark}}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <H-Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
    </a-spin>


    <a-modal v-model="history" @ok="handleHistory" :footer="null">
      <span slot="title">
        <a-icon type="reload" />&nbsp;History Status
      </span>

      <ul class="list-wrapper bordered">
        <li v-for="history in basedData.notifikasi" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="d-flex justify-between">
              <h3 class="m-remove list-title">{{history.as_from}} | {{history.tlc_from}}</h3>
              <H-Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{history.tgl_notif}}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="d-flex justify-between">
              <h3
                class="m-remove list-title"
                v-if="(history.aksi === '4' && history.deskripsi === 'Edited') || history.deskripsi === 'Revised'"
              >{{history.as_from}} | {{history.tlc_from}}</h3>
              <h3 class="m-remove list-title" v-else>{{history.as_to}} | {{history.tlc_to}}</h3>
              <H-Status :status="history.deskripsi" />
            </div>
            <span class="list-desc">{{history.tgl_notif}}</span>
          </div>
        </li>
      </ul>
    </a-modal>


  </a-layout-content>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import Status from "@/components/Status.vue";
export default {
  props: {
    id: String
  },
  components: {
      "H-Status": Status
  },
  name: "ManifestAlokasi",
  beforeCreate() {
      this.form = this.$form.createForm(this);
  },
  data() {
    return {
      basedData: {},
      pagination: {
        onChange: page => {
          console.log(page);
        },
        pageSize: 5,
        size: "small"
      },
      monitoring: false,
      pageLoading: false,
      printLoading: false,
      history: false,
        activeKey: ['1'],
      visiblemenupopover: false,
      table_pekerjaan: {
        loading: false,
        columns: [
          {
            title: 'No',
            scopedSlots: { customRender: "no" },
            width: "50px",
            key: 'no',
            align: "right"
          },
          {
            title: 'Persentase',
            width: "100px",
            align: "right",
            key: 'persentase',
            scopedSlots: { customRender: "persentase" },
          },
          {
            title: 'Kode Proyek',
            key: 'kode_proyek',
            width: "150px",
            align: "center",
            dataIndex: "c_proyek",
          },
          {
            title: 'Deskripsi',
            key: 'deskripsi',
            scopedSlots: { customRender: "deskripsi" },
          },
        ],
        pagination: {
          page: 1,
          onChange: (page) => {
            this.table_pekerjaan.pagination.page = page;
          },
          pageSize: 5,
          size: "default"
        },
      },
    };
  },
  watch: {
    id() {
      if (this.id) {
        this.fetching();
      }
    }
  },
  created() {
    this.fetching();
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat","getStandartFormatDate"])
  },

  methods: {
    moment,
    async fetching() {
      await axios({
        method: "get",
        url: this.$serviceUrl + "rekap_alokasi",
        params: {
          tlc: this.getAuth.username,
          id_manifest: this.id
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          if (response.data) {
            this.basedData = {
              header: response.data.header[0],
              detail: response.data.detail,
              notifikasi: response.data.notifikasi,
              status_app :   response.data.status_app,
              status: response.data.status,
              jenis: response.data.jenis,
              id_manifest: response.data.id_manifest,
              aksi: response.data.aksi

            };
          }
        })
        .catch(err => {
          console.log(err.response);
        });
    },
    handlePrint() {
      this.printLoading = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "rekap_alokasi/cetak_alokasi",
        responseType: "blob",
        params: {
          id_alokasi: this.id
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.printLoading = false;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.$notification.error({
              message: "Error",
              description: "Gangguan System, error code 404!"
            });
          }
          this.printLoading = false;
          this.$router.go();
        });
    },
    handleHistory(event) {
        this.history = true;
        event.stopPropagation();
    },
    handleAction(){
        this.confirmMessage("confirm-save");
    },
    handleActionProcess() {
        this.form.validateFields((err, values) => {
            if (err) {
                this.$notification.error({
                    message: "Error",
                    description: "Pilih Aksi Terlebih Dahulu!"
                });
                return;
            }
            axios({
                method: "post",
                url: this.$serviceUrl + "rekap_alokasi/approval",
                processData: false,
                data: {
                    id_manifest: this.id,
                    tlc: this.getAuth.username,
                    status: values.aksi,
                    remark: values.catatan ? values.catatan : ""
                },
                auth: {
                    username: this.getAuth.username,
                    password: this.getAuth.password
                },
                headers: {
                    "Content-Type": "application/json",
                    "X-API-KEY": this.getAuth.apikey
                }
            })
                .then(response => {
                    this.$notification.success({
                        message: "Sukses",
                        description: "Data telah berhasil diproses!"
                    });
                    Event.$emit("refreshNotification", true);
                    this.$router.go();
                })
                .catch(err => {
                    console.log("error : " + err);
                });
        });
    },
    handleEdit(){
      this.$router.push({ name: "edit.alokasi", params: {id: this.id} });
    }
  },
  mounted() {
    Event.$on("confirmMessageReturn", this.handleActionProcess);
    if (
      this.$router.currentRoute.name == "hrd.mon.manifest.alokasi" ||
      this.$router.currentRoute.name == "al.mon.manifest.alokasi" ||
      this.$router.currentRoute.name == "dir.mon.manifest.alokasi"
    ) {
      this.monitoring = true;
    } else {
      this.monitoring = false;
    }
  }
};
</script>

<style>
</style>
